export default "__VITE_ASSET__1e6270ab__"